// extracted by mini-css-extract-plugin
export default {"zoomModal":"a2-z"};